import React from 'react';
import { Button, Modal, Form, InputLabel, RadioLabel, Icon, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { useForm } from '../../../../utils/validators';
import CrossSellingModel from '../../../../models/crossSellingModel';

export default function DuplicateModal({ organization, selectedProduct, openDuplicateModal, setOpenDuplicateModal, sync }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const [form, setForm, setFormObject] = useForm({
        name: '',
        visible: true
    });
    React.useEffect(() => {
        // once we have selected product we set name
        setFormObject({
            name: `${selectedProduct?.name} - Copy`,
            visible: !selectedProduct?.disabled
        });
    }, [selectedProduct]);

    const onDuplicate = React.useCallback(() => {
        setIsSubmitting(true);
        return CrossSellingModel.duplicate_action({
            organizationId: organization.id,
            productId: selectedProduct.id,
            name: form.name,
            visible: form.visible
        })
            .then(() => {
                toast.success(t('ticket.cross-selling.duplicate.toast-success'));
                sync({
                    cache: false
                });
            })
            .catch(e => {
                console.error(e);
                toast.error(t('ticket.cross-selling.duplicate.toast-error'));
            })
            .finally(() => {
                setIsSubmitting(false);
                setOpenDuplicateModal(false);
            });
    }, [organization, selectedProduct, toast, form, sync]);

    return (
        <Modal
            size="medium"
            open={openDuplicateModal}
            allowExternalClosing={false}
            onClose={() => setOpenDuplicateModal(false)}
            title={t('ticket.cross-selling.duplicate.title')}
            subtitle={t('ticket.cross-selling.duplicate.subtitle')}
            submitButton={<Button primary isLoading={isSubmitting} onClick={() => onDuplicate()} label={t('ticket.common.action.duplicate')} />}
            cancelButton={<Button onClick={() => setOpenDuplicateModal(false)} label={t('ticket.common.action.cancel')} />}
        >
            <Form.Label>{t('ticket.cross-selling.add.visibility')}</Form.Label>
            <div>
                <RadioLabel inline bordered checked={form.visible} onClick={() => setForm('visible', true)} name="visible">
                    {t('ticket.cross-selling.add.visibleOnline')} {<Icon name="eye" />}
                </RadioLabel>
                <RadioLabel inline bordered checked={!form.visible} onClick={() => setForm('visible', false)} name="non-visible">
                    {t('ticket.common.action.hide-online')} {<Icon name="eye-slash" />}
                </RadioLabel>
            </div>
            <div>
                <InputLabel label={t('ticket.cross-selling.duplicate.input-title')} />
                <Form.Input placeholder={t('ticket.cross-selling.duplicate.input-placeholder')} value={form.name} onChange={(e, { value }) => setForm('name', value)} />
            </div>
        </Modal>
    );
}
